import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'vidyshort-auth',
  },
  global: {
    // Only apply timeout to regular API calls — never to storage uploads/downloads
    fetch: (url: RequestInfo | URL, options: RequestInit = {}) => {
      const urlStr = url.toString()

      // Storage uploads/downloads — no timeout, they can take minutes
      const isStorage = urlStr.includes('/storage/') || urlStr.includes('/object/')
      if (isStorage) {
        return fetch(url, options)
      }

      // Regular API calls — 10 second timeout to prevent infinite hangs
      const controller = new AbortController()
      const timer = setTimeout(() => controller.abort(), 10000)

      // If the caller already passed a signal, respect it too
      const existingSignal = options.signal as AbortSignal | undefined
      if (existingSignal) {
        existingSignal.addEventListener('abort', () => controller.abort())
      }

      return fetch(url, { ...options, signal: controller.signal })
        .finally(() => clearTimeout(timer))
    },
  },
})